module.exports = __webpack_public_path__ + "static/f-randy-vogenberg-fce072c06e7018258cbda732b3d97429.png";